import styled from '@emotion/styled';
import { space } from 'styled-system';
import { StyledProps } from './Header.types';
import { Theme } from '../Modal.types';
import { css } from '@styled-system/css';
import { variant } from 'styled-system';

export default styled.div<StyledProps, Theme>`
  ${space}
  ${css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottom: '1px solid var(--color-indigo-t1)',
    paddingBottom: '24px',
    fontSize: '28px',
    lineHeight: '32px',
  })}
  ${variant({
    prop: 'mode',
    variants: {
      default: { color: 'var(--color-indigo-t11)' },
      error: { color: 'var(--color-coral)' },
    },
  })}
`;
